import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginGuard } from './theme/shared/guards/login.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./theme/layout/auth/auth.module').then(mod => mod.AuthModule),
    canActivate:[LoginGuard]
  },
  {
    path: '',
    loadChildren: () => import('./theme/layout/admin/admin.module').then(mod => mod.AdminModule),
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
